import { render, staticRenderFns } from "./AccrualsIngestion.vue?vue&type=template&id=4bbbe5e0"
import script from "./AccrualsIngestion.vue?vue&type=script&lang=js"
export * from "./AccrualsIngestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports